export default __webpack_public_path__ + "static/media/ag-girl.d7ca74ce.webp";